export default {
  path: 'aggregator/approvals',
  name: 'Aggregator_approvals',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/AggregatorApprovalsMain.vue')
}
